export const ACCOUNTING_MODULE_LABEL: Record<string, string> = {
  ar_gl: 'Accounts Receivable GL',
  settlement_gl: 'Settlement GL',
  refund_reversal_gl: 'Refund Reversal GL',
  ap_bills: 'Accounts Payable — Bills',
  ap_payment_gl: 'Accounts Payable — Payments',
  tax_remittance_gl: 'Tax Remittance GL',
  commerce_deposits_gl: 'Commerce Deposits GL',
  membership_deferral_gl: 'Membership Deferral GL',
  cash_basis: 'Cash Basis Reporting',
  ap_checks: 'AP Freeform Checks GL',
  payroll_gl: 'Payroll GL',
  comp_expense_gl: 'Comp Expense GL',
  rounding_gl: 'Cash Rounding GL',
  inventory_noncogs_gl: 'Inventory Non-COGS GL',
};

export const ACCOUNTING_MODULE_DESCRIPTION: Record<string, string> = {
  ar_gl:
    'Writes journal entries for all customer invoices, receipts, write-offs, and chargebacks in the AR sub-ledger.',
  settlement_gl:
    'Writes journal entries when card-payment settlements are posted from the payment processor.',
  refund_reversal_gl:
    'Writes reversal journal entries for customer refunds, netting against the original AR entry.',
  ap_bills: 'Writes journal entries when vendor bills are approved or voided in the AP sub-ledger.',
  ap_payment_gl: 'Writes journal entries when vendor payments are issued or returned.',
  tax_remittance_gl: 'Writes journal entries when sales-tax remittance payments are recorded.',
  commerce_deposits_gl:
    'Writes deferred liability entries when customer deposits are received and clears them on application.',
  membership_deferral_gl:
    'Writes deferred revenue entries for membership fees and recognizes them as earned over the period.',
  cash_basis:
    'Switches P&L reports from accrual to cash basis. Requires AR GL, AP Bills, and AP Payments active.',
  ap_checks:
    'Writes journal entries when freeform AP checks are issued, routing them through the AP cash-in-transit account.',
  payroll_gl:
    'Writes journal entries when payroll runs are exported, posting wages, employer taxes, net pay, and tax liability.',
  comp_expense_gl:
    'Reclassifies comp adjustments from contra-revenue (sales discounts) to comp expense, restoring accurate gross revenue.',
  rounding_gl:
    'Posts cash-rounding adjustment entries to a clearing account when orders are rounded to the nearest cash denomination.',
  inventory_noncogs_gl:
    'Posts non-COGS inventory shrinkage and variance entries for waste, adjustments, and cycle-count discrepancies.',
};

export const ACCOUNTING_MODULE_GL_ENTRIES: Record<string, string> = {
  ar_gl:
    'DR Accounts Receivable / CR Revenue (invoice); DR Cash / CR AR (receipt); DR Revenue / CR AR (write-off)',
  settlement_gl: 'DR Cash / CR Accounts Receivable (settlement posted)',
  refund_reversal_gl: 'DR Revenue / CR Accounts Receivable (refund issued)',
  ap_bills: 'DR Expense / CR Accounts Payable (bill approved); reversal on void',
  ap_payment_gl: 'DR Accounts Payable / CR Cash (payment issued); DR Cash / CR AP (returned)',
  tax_remittance_gl: 'DR Sales Tax Payable / CR Cash (remittance recorded)',
  commerce_deposits_gl:
    'DR Cash / CR Customer Deposit Liability (received); DR Liability / CR Revenue (applied)',
  membership_deferral_gl:
    'DR Cash / CR Deferred Revenue (paid); DR Deferred Revenue / CR Revenue (recognized per period)',
  cash_basis: 'No new GL writes — changes report filters to cash-received/paid basis for P&L',
  ap_checks:
    'DR Expense Account / CR AP Cash-in-Transit (20050) on check issuance; transit cleared when check clears bank',
  payroll_gl: 'DR Wage Expense + DR Employer Tax Expense / CR Payroll Clearing + CR Tax Liability',
  comp_expense_gl:
    'DR Comp Expense (631000) / CR Sales Discounts (49800) — nets the already-posted contra-revenue',
  rounding_gl:
    'DR Cash-Bolt-Settlement / CR Rounding Reconciliation (999000) for rounded-up; reversed for rounded-down',
  inventory_noncogs_gl:
    'DR Inventory Shrinkage Expense (632000) / CR Inventory Asset on loss; reversed for found-stock gain',
};

export const ACCOUNTING_MODULE_DEPENDENCIES_LABEL: Record<string, string[]> = {
  ar_gl: [],
  settlement_gl: ['AR GL'],
  refund_reversal_gl: ['AR GL'],
  ap_bills: ['AR GL'],
  ap_payment_gl: ['AR GL', 'AP Bills'],
  tax_remittance_gl: ['AR GL', 'AP Bills'],
  commerce_deposits_gl: ['AR GL'],
  membership_deferral_gl: ['AR GL'],
  cash_basis: ['AR GL', 'AP Bills', 'AP Payments'],
  ap_checks: [],
  payroll_gl: [],
  comp_expense_gl: [],
  rounding_gl: [],
  inventory_noncogs_gl: [],
};

export const ACCOUNTING_MODULE_TIER_LABEL: Record<number, string> = {
  1: 'Foundation',
  2: 'Receipts & Refunds',
  3: 'Payables',
  4: 'Tax',
  5: 'Deferred Liabilities',
  6: 'Reporting',
};
